import brand from "@/config/brand";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {brand.marqueeItems.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif italic text-xl sm:text-2xl text-champagne/50 px-8 whitespace-nowrap">
          {item}
        </span>
        <svg width="8" height="8" viewBox="0 0 8 8" className="shrink-0">
          <circle cx="4" cy="4" r="3" fill="#00AFA3" fillOpacity="0.7" />
        </svg>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-charcoal border-y border-champagne/10 py-7 overflow-hidden"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;
